import { useEffect } from "react";
import { UPDASP_link } from "../urlconfig";

const UpdaspLayout = () => {
  useEffect(() => {
    window.history.pushState({}, undefined, window.location.pathname);
    window.location.href = UPDASP_link;
  }, []);
  return;
};

export default UpdaspLayout;
